import { StepProps, useAutoNavigate } from '@betterment/js-runtime';
import { Box, Button, Text, VStack } from '@betterment/samba-react';

import StepHeading from '../../AccountCreationFlow/components/StepHeading';
import { WorkflowLayout } from '../../Shared/layout/WorkflowLayout';

export const ContactAdvisorStep: React.FC<StepProps> = ({ flowState }) => {
  const navigate = useAutoNavigate();

  const handleClose = () => navigate(flowState.returnToPath);

  return (
    <WorkflowLayout pageTitle="Securities Lending" workflowTitle="" onClose={handleClose}>
      <VStack>
        <StepHeading>Please contact your advisor.</StepHeading>
        <Text>To make changes to your securities lending preferences, please contact your advisor.</Text>
        <Box css={{ marginTop: 'space.200' }}>
          <Button type="button" onClick={handleClose} variant="solidPrimary">
            Close
          </Button>
        </Box>
      </VStack>
    </WorkflowLayout>
  );
};
